import gql from 'graphql-tag';
export default gql`
	query ModalLogin {
		modalLogin @client {
			isOpen
		}
	}
`;
